module.exports = __webpack_public_path__ + "static/media/OCEAN.70b631a9.svg";